export default "/react/logoJetStat-a4dedf9d.png";